import { render, staticRenderFns } from "./ShowSwapTopicDialog.vue?vue&type=template&id=1543e526&"
import script from "@/components/topic-row/ShowSwapTopicDialog.ts?vue&type=script&lang=ts&"
export * from "@/components/topic-row/ShowSwapTopicDialog.ts?vue&type=script&lang=ts&"
import style0 from "./show-swap-topic-dialog.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports